import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import {UiSettingsService} from '../../shared/ui-settings.service';
import {AutomationMapping} from '../interfaces/automationMapping';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class AutomationMappingService extends GeneralService<AutomationMapping> {

  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'automationmappings', 'automationmapping', 'rego');
  }
}
